<template>
  <div v-if="currentTraining != null">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-body">
            <div class="box-group" id="accordion">
              <div class="panel box box-primary">
                <div class="box-header with-border">
                  <h4 class="box-title">
                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseHelpPhoto"
                       aria-expanded="true"
                       class="collapsed">
                      {{$t('help.title')}}
                    </a>
                  </h4>
                </div>
                <div id="collapseHelpPhoto" class="panel-collapse collapse" aria-expanded="true"
                     style="height: 0px;">
                  <div v-if="$root.$i18n.locale == 'en'" class="box-body">
                    <p>We encourage you to add high-resolution photos to present sports camps. That is at least
                      1024 px in width. </p>

                  </div>
                  <div v-if="$root.$i18n.locale == 'ru'" class="box-body">
                    <p>Настоятельно рекомендуем использовать фото высокого качества (разрешение не менее 1024 px
                      в ширину).</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="photo-list">
          <div
            v-for="photo in currentTraining.photos"
            :key="photo">
            <div class="box box-widget box__photo">
              <div class="box-body">
                <div class="box-tools">
                  <button type="button" v-on:click="deletePhoto(photo)"
                          class="btn btn-box-tool btn-box-tool__absolute">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <img class="img-responsive pad"
                     :src="'http://file.sportlane.com/minImages/800/' + photo"
                     alt="Photo">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{$t('trainings.photos.added-form.title')}}</h3>
          </div>
          <form role="form">
            <div class="box-body">
              <div class="form-group">
                <label for="file">{{$t('trainings.photos.added-form.import')}}</label>
                <input type="file" id="file" ref="myFiles" class="custom-file-input"
                       @change="previewFiles" multiple>
              </div>
            </div>
            <div class="box-footer">
              <button v-on:click="addPhoto" type="button" class="btn btn-primary">
                {{$t('trainings.photos.added-form.submit')}}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-primary">Save changes</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TrainingPhotos',
  props: {
    currentTraining: Object
  },
  data () {
    return {
      files: []
    };
  },
  methods: {
    previewFiles () {
      this.files = this.$refs.myFiles.files;

      console.log(this.files);
    },
    deletePhoto (photo) {
      var self = this;

      var photoId = photo.split('/')[1].split('.')[0];

      axios.delete(window.host + '/trainings/' + self.currentTraining.id + '/photos/' + photoId)
        .then(function (response) {
          console.log(response.data);

          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', self.currentTraining.id);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    addPhoto () {
      var self = this;
      console.log(this.files);

      for (var i = 0; i < this.files.length; i++) {
        var formData = new FormData();
        formData.append('image', self.files[i]);

        console.log(self.files.length);
        // return;
        axios.post('/images/', formData)
          .then(function (response) {
            console.log(response.data);

            var url = response.data;

            var data = {
              url: url
            };

            axios.post(window.host + '/trainings/' + self.currentTraining.id + '/photos', data)
              .then(function (responseAdd) {
                console.log(responseAdd.data);

                self.$root.$emit('alert', 'success', 'alert.success');
                self.$root.$emit('updateTraining', self.currentTraining.id);
              })
              .catch(function (errorAdd) {
                console.log(errorAdd);
                self.$root.$emit('alert', 'error', 'alert.error');
              });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped>
  .modal-dialog-l {
    width: 80%;
  }

  .modal-body__photos {
    background-color: #ecf0f5;
  }

  .btn-box-tool__absolute {
    position: absolute;
    top: -3px;
    right: 0;
  }

  .photo-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .box__photo {
    width: 200px;
  }
</style>
